package com.damda.webapp

import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.damda.design_system.core.ImageResourceLoader
import com.damda.design_system.ui.views.core.ComposeWindowWidthSizeClass
import com.damda.design_system.ui.views.core.MyApp
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.renderComposableInBody
import org.w3c.dom.events.Event

fun main() {
    renderComposableInBody {

        var windowSize by remember { mutableStateOf(ComposeWindowWidthSizeClass.Small) }
        DisposableEffect(Unit) {
            val resizeListener: (Event) -> Unit = {
                val newWindowSize = when {
                    window.innerWidth < 600 -> ComposeWindowWidthSizeClass.Small
                    window.innerWidth < 1200 -> ComposeWindowWidthSizeClass.Medium
                    else -> ComposeWindowWidthSizeClass.Large
                }
                windowSize = newWindowSize
            }

            window.addEventListener("resize", resizeListener)
            resizeListener(Event(""))

            onDispose {
                window.removeEventListener("resize", resizeListener)
            }
        }

        MyApp(windowSize, ImageResourceLoader())
    }
}